import { IconComponent } from 'models/icons';

/**
 * This file was auto-generated using svgr
 *
 * Source file: assets/icons/world.svg
 */
const IconZIP: IconComponent = ({
  size = 24,
  color = 'white',
  className,
  svgElementProps: props = {},
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    color={color}
    className={className}
    {...props}
  >
    <path d="m17.005 2.73 -1.726 -0.999L16.275 0 18 0.999l-0.995 1.731zm-0.87 1.669 -1.809 -0.678 -0.681 1.88 1.808 0.677 0.682 -1.879zM14.987 8H13v2h1.987V8zM6 0.999 7.725 0l0.996 1.731 -1.726 0.999L6 0.999zm2.547 5.28 1.808 -0.677 -0.681 -1.88 -1.809 0.677 0.682 1.88zM9.013 10H11V8H9.013v2zm7.837 9 -1.852 -7H9.002L7.15 19c-0.786 3.156 1.602 5 4.85 5 3.252 0 5.635 -1.848 4.85 -5zm-7.848 1.125c0 -2.627 5.992 -2.688 5.992 -0.007 0 2.555 -5.992 2.536 -5.992 0.007z" />
  </svg>
);

export default IconZIP;
